// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats__nUiqK","title":"Stats_title__zyEBK","value":"Stats_value__7VI8F","subtitle":"Stats_subtitle__xnFpX"};